import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import {fileTypeFetchData} from '../../actions/fileData'
import Loader from '../../components/Loader';
import { setSearchScope } from '../../helpers';
class FileType extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [
        {
            Header: 'Actief',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },
        {
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/filetype/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }
        ]

        this.columns = false;


    }

    componentDidUpdate(prevProps) {
        if(prevProps.fileTypeData != this.props.fileTypeData) {
            this.props.updateSearchData(this.props.fileTypeData.data)
            this.columns = this.props.fileTypeData.columns
        }
    }

	componentWillMount() {
		setSearchScope('filetype');
    	if(this.props.clientPath) {
            this.props.fileTypeFetchData(this.props.clientPath.clientPath)
        }
  	}

	render() {

        return (
            <Card>
				<CardHeader>
				{ this.props.fileTypeData.data ? <Search data={this.props.fileTypeData.data} keys_to_filter={['category']}/> : null }</CardHeader>
                <CardBody>
                    <CardTitle><i className="fa fa-align-justify"></i> Bestandstype overzicht</CardTitle>
                    {this.columns ? <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.fileTypeData.data} columns={this.props.fileTypeData.columns} /> : <Loader /> }
                </CardBody>
            </Card>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        fileTypeData: state.FileTypeDataReducer,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        fileTypeFetchData: (url) => dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes'))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileType)



// WEBPACK FOOTER //
// ./src/views/Filetype/index.js